import { Check, MessageSquare, Send } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ChatList } from 'types/api'

import { cn } from '@/lib/utils'

interface ChatListItemProps {
  item: ChatList
  onClick: (id?: string) => void
  key?: string
}

export function ChatListItem({ item, onClick }: ChatListItemProps) {
  const { t } = useTranslation('chat')

  return (
    <button
      type="button"
      onClick={() => onClick(item.id)}
      className="flex w-full items-center gap-4 rounded-2xl border-0 bg-transparent p-3 text-left transition-colors hover:bg-ink/[0.04]"
    >
      <span
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold',
          item.has_new_messages
            ? 'bg-primary text-white'
            : 'bg-ink/[0.05] text-primary'
        )}
      >
        {item.has_new_messages ? '+1' : <MessageSquare className="h-5 w-5" />}
      </span>
      <span className="min-w-0 flex-1 truncate font-medium text-ink">
        {item.title}
      </span>
      {item.is_read ? (
        <Check
          className="h-4 w-4 shrink-0 text-[#16dd88]"
          aria-label={t('form.common.seen')}
        />
      ) : (
        <Send
          className="h-4 w-4 shrink-0 text-ink/30"
          aria-label={t('form.common.sent')}
        />
      )}
    </button>
  )
}
